import { useApi } from '@backstage/frontend-plugin-api';
import { notificationsApiRef } from '@backstage/plugin-notifications';
import { useEffect, useState } from 'react';

const POLL_INTERVAL_MS = 60_000;

/** Polls the unread notification count for the top-bar bell badge; a new `reloadKey` re-reads it at once. */
export const useUnreadNotificationsCount = (reloadKey = 0) => {
  const notificationsApi = useApi(notificationsApiRef);
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const status = await notificationsApi.getStatus();
        if (!cancelled) setCount(status.unread);
      } catch {
        // Bell just shows no badge; the notifications page itself surfaces errors.
      }
    };

    void load();
    const interval = setInterval(load, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [notificationsApi, reloadKey]);

  return count;
};
